import { useQuery } from '@tanstack/react-query';
import {
  getDeliveries, type DeliveryFilters 
} from '../api';

export function useDeliveries(siteId: string, filters?: DeliveryFilters) {
  return useQuery({
    queryKey: ['deliveries', siteId, filters],
    queryFn: () => getDeliveries(siteId, filters),
    enabled: Boolean(siteId),
  });
}
